(ns ycweb.app.website.dlp.widgets.simplevideo
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.util.core :as u]))

(rum/defc simple-video < rum/reactive [{:keys [properties uuid]}]
  (let [{:simple-video/keys [video-type video-embed-source video-width image-shadow? on-page-link-id]} properties]
    (when (and (u/presence video-type) (u/presence video-embed-source))
      [:div.yc-section
       {:id (when (u/presence on-page-link-id) on-page-link-id)}
       [:div.video-wrapper.u-block-center
        {:id (when (and uuid (= video-type "iframe")) (str "js-" uuid))
         :class
         [(str "u-max-width-" (cond (= video-width "small") "480" :else "720"))
          (when-not (= video-type "iframe") (when (trf/toboolean image-shadow?) "yc-simple-image--shadow"))]}
        (cond
          (= video-type "iframe")
          [:div.fluid-width-video-wrapper
           {:style
            {:position "relative"
             :width "100%"
             :padding-top "50%"}}
           [:iframe
            {:src video-embed-source
             :frameBorder 0
             :allowFullScreen true
             :loading "lazy"
             :class (when (trf/toboolean image-shadow?) "yc-simple-image--shadow")
             :name "fitvid0"
             :style
             {:position "absolute"
              :top 0
              :left 0
              :width "100%"
              :height "100%"}}]]

          :else
          [:div
           {:dangerouslySetInnerHTML
            {:__html
             (str "<script src='" video-embed-source "'></script>")}}])]])))
